// File: frontend/src/components/layout/Footer.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// --- FIX: API aur Icons ko import karein ---
import { addSubscriber } from '../../services/api';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
// --- End of Fix ---
import './Footer.css'; // Humari nayi CSS file

const Footer = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // --- FIX: Subscribe form ke liye handler ---
    const handleSubscribe = async (e) => {
        e.preventDefault();
        setMessage('');

        try {
            const res = await addSubscriber(email);
            setMessage(res.data.msg);
            setEmail('');
        } catch (err) {
            const errorMsg = err.response?.data?.msg || 'An error occurred.';
            setMessage(errorMsg); // Use same message state for success/error
        }
    };
    // --- End of Fix ---

    return (
        // --- FIX: Naya Dark Footer Layout ---
        <footer className="site-footer-dark">
            <div className="container">
                <div className="footer-grid">

                    {/* --- Column 1: Brand & Social --- */}
                    <div className="footer-col footer-col-brand">
                        <h2 className="footer-logo">INDIA JAGRAN</h2>
                        <p className="footer-tagline">नास्ति सत्यात् परो धर्मः</p>
                        <div className="footer-social-icons">
                            <a href="https://www.youtube.com/YourChannel" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
                            <a href="https://www.facebook.com/YourPage" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
                            <a href="https://www.x.com/YourHandle" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaXTwitter /></a>
                            <a href="https://www.instagram.com/YourProfile" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                        </div>
                    </div>

                    {/* --- Column 2: Quick Links --- */}
                    <div className="footer-col footer-col-links">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/advertise">Advertise</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/terms-condition">Terms & Condition</Link></li>
                        </ul>
                    </div>

                    {/* --- Column 3: Categories --- */}
                    <div className="footer-col footer-col-links">
                        <h4>Categories</h4>
                        <ul>
                            <li><Link to="/category/national">National</Link></li>
                            <li><Link to="/category/sports">Sports</Link></li>
                            <li><Link to="/category/business">Business</Link></li>
                            <li><Link to="/category/entertainment">Entertainment</Link></li>
                            <li><Link to="/category/world">World</Link></li>
                            <li><Link to="/category/tech">Tech</Link></li>
                        </ul>
                    </div>

                    {/* --- Column 4: Subscribe --- */}
                    <div className="footer-col footer-col-subscribe">
                        <h4>Subscribe to our Newsletter</h4>
                        <p>Get the latest news headlines delivered right to your inbox.</p>
                        <form className="footer-subscribe-form" onSubmit={handleSubscribe}>
                            <input 
                                type="email" 
                                placeholder="Your Email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required 
                            />
                            <button type="submit">Subscribe</button>
                        </form>
                        {message && <p className={`footer-subscribe-status ${message.includes('Thank you') ? 'success' : 'error'}`}>{message}</p>}
                    </div>

                </div>
                
                {/* --- Bottom Sub-Footer --- */}
                <div className="footer-bottom">
                    <p>Copyright &copy; 2025 India Jagran. All rights reserved.</p>
                </div>
            </div>

            {/* Scroll to Top Button (Aapka purana code, jo sahi hai) */}
            <button onClick={scrollToTop} className="scroll-to-top" aria-label="Scroll to top">
                &#8593;
            </button>
        </footer>
        // --- END OF FIX ---
    );
};

export default Footer;